
import React from 'react';
import Form from "./Form";
import LoadMask from "../../Utils/LoadMask";
import { connect } from "react-redux";
import { actions } from '../../../../redux/modules/erp_issue';


const Create = (props) => {

    const {
        loading,
        create,
        formValues,
    } = props;

    const readAsyncFile = (file) => new Promise((res) => {
        const reader = new FileReader();
        const result = {};
        reader.onload = () => {
            result.buffer = reader.result;
            result.name = file.name;
            result.size = file.size;
            result.type = file.type;
        };
        reader.onloadend = () => res(result);
        reader.readAsArrayBuffer(file);
    })

    const submitForm = async (formData) => {
        try {
            const screenshots = [];
            for(let i=0; i<formData.screenshots.length; i+=1) {
                const result = await readAsyncFile(formData.screenshots[i]);
                screenshots.push(result);
            }
            const additional_files = [];
            for(let i=0; i<formData.additional_files.length; i+=1) {
                const result = await readAsyncFile(formData.additional_files[i]);
                additional_files.push(result);
            }
            const data = {
                ...formData,
                screenshots,
                additional_files,
            }
            create(data)
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <LoadMask loading={loading} dark blur>
            <Form
                onSubmit={submitForm}
                formValues={formValues}
            />
        </LoadMask>
    )
};

const mstp = (state) => ({
    ...state.erp_issue,
    formValues: state.form && state.form.erp_issue && state.form.erp_issue.values
})

export default connect(mstp, actions)(Create);
